import { makeAutoObservable, runInAction } from "mobx";
import { callRemoteMethod } from "../utils/WebserviceHandler";
import CONSTANTS from "../utils/constants";
import General from "./GeneralStore";
import User from "./UserStore";
import { ErrorWrapper } from "../utils/ErrorWrapper";
import axios from "axios";

interface Obj {
  [key: string]: any;
}

class PaymentPlan {
  serviceAccounts: Obj[] = [];
  connectorAccounts: Obj[] = [];

  selectedServiceAccounts: Obj = {};
  selectedConnectorAccounts: Obj = {};

  //  Combine service & connector accounts

  accounts: Obj[] = [];

  summary: Obj = {};
  plan: Obj = {};

  amountValidation: Obj = {};
  bankDetails: Obj = {};
  calculatedPlan: Obj = {};
  updateCheckdetails: Obj = {};

  numServiceAccounts: number = 0;
  numDefaultAccounts: number = 0;
  numConnectedAccounts: number = 0;
  numNotConnectedAccounts: number = 0;

  serviceTotalDue: number = 0;
  defaultTotalDue: number = 0;
  connectedTotalDue: number = 0;
  notConnectedTotalDue: number = 0;

  constructor() {
    makeAutoObservable(this); //persist
  }
  //service/GetAdvanceAmountforPayPlan/<personId>/<accountType>
  getAdvanceAmountService = ErrorWrapper(async (id: string) => {
    const res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.PAYPLAN_ADVANCE_AMOUNT(id, "SERVICE"),
    });

    let completeArr: Obj[] = [];

    if (res.result?.output.uosAccounts) {
      const temp = res.result?.output.uosAccounts.map((account: Obj) => {
        return {
          ...account,
          accountGroup: "SERVICE",
          accountType: "UOS", //UoS Account
          sewerageNo: account.premiseId,
          amountDue: account.currentBalance,
          premiseDetails: account.premiseAddress,
          premiseUsage: account.propertyUsage,
          showRecord: true, //TODO: Shu wad3on haw ?!!!
          isChecked: true, //TODO: Shu wad3on haw ?!!!
        };
      });

      completeArr = [...completeArr, ...temp];
    }
    if (res.result?.output.defaultAccounts) {
      const temp = res.result?.output.defaultAccounts.map((account: Obj) => {
        return {
          ...account,
          accountGroup: "SERVICE",
          accountType: "DEFAULT",
          sewerageNo: account.premiseId,
          amountDue: account.currentBalance,
          premiseDetails: account.premiseAddress,
          premiseUsage: account.propertyUsage,
          showRecord: true, //TODO: Shu wad3on haw ?!!!
          isChecked: true, //TODO: Shu wad3on haw ?!!!
        };
      });

      completeArr = [...completeArr, ...temp];
    }
    console.log("**********LOOK HERE:", completeArr);
    runInAction(() => {
      this.serviceAccounts = completeArr;
    });
  });

  getAdvanceAmountConnector = ErrorWrapper(async (id: string) => {
    const res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.PAYPLAN_ADVANCE_AMOUNT(id, "CONNECTOR"),
    });

    let completeArr: Obj[] = [];

    if (res.result?.output.connectedAccounts) {
      const temp = res.result?.output.connectedAccounts.map((account: Obj) => {
        return {
          ...account,
          accountGroup: "CONNECTOR",
          accountType: "CONNECTED",
          sewerageNo: account.premiseId,
          amountDue: account.currentBalance,
          premiseDetails: account.premiseAddress,
          premiseUsage: account.propertyUsage,
          showRecord: true, //TODO: Shu wad3on haw ?!!!
          isChecked: true, //TODO: Shu wad3on haw ?!!!
        };
      });

      completeArr = [...completeArr, ...temp];
    }

    if (res.result?.output.notConnectedAccounts) {
      const temp = res.result?.output.notConnectedAccounts.map(
        (account: Obj) => {
          return {
            ...account,
            accountGroup: "CONNECTOR",
            accountType: "NOT_CONNECTED",
            sewerageNo: account.premiseId,
            amountDue: account.currentBalance,
            premiseDetails: account.premiseAddress,
            premiseUsage: account.propertyUsage,
            showRecord: true, //TODO: Shu wad3on haw ?!!!
            isChecked: true, //TODO: Shu wad3on haw ?!!!
          };
        }
      );

      completeArr = [...completeArr, ...temp];
    }

    runInAction(() => {
      this.connectorAccounts = completeArr;
    });
  });

  getAllPDCs = ErrorWrapper(async ({ personId }: { personId: string }) => {
    const res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.GET_ALL_PDCS(personId),
    });

    runInAction(() => {
      this.summary = res.result;
    });
  });

  calculatePaymentPlan = ErrorWrapper(
    async ({
      personId,
      firstCheckDate,
    }: {
      personId: string;
      firstCheckDate: string;
    }) => {
      const accounts = [
        ...Object.values(this.selectedServiceAccounts),
        ...Object.values(this.selectedConnectorAccounts),
      ];

      const data = {
        personId,
        accounts,
      };

      const res = await callRemoteMethod({
        endpoint: CONSTANTS.URL.PAYMENT_PLAN_CALCULATE,
        type: "POST",
        data,
      });

      runInAction(() => {
        this.calculatedPlan = res;
        this.accounts = accounts;
      });
    }
  );
  updateCheck = ErrorWrapper(async (data:any) => {

      const res = await callRemoteMethod({
        endpoint: CONSTANTS.URL.PDC_UPDATE_CHECK_DETAILS,
        type: "POST",
        data,
      });

      runInAction(() => {
       this.updateCheckdetails=res?.result
      });
      return res;
    }
  );

  createPaymentPlan = ErrorWrapper(
    async (unprocessedData: {
      personId: string;
      personName: string;
      payorMobileNum: string;
      payorAuthorizedSignatory: string;
      makaniNumber: string;
      buildingName: string;
      area: string;
      property: string;
      street: string;
      emirateId: string;
      totalAmount: number;
      CurrentAmountPercent:number;
      CheckAmount:number;
      CurrentPaymentAmount:number;
      FullPaymentAmount:number;
      connectedTotalDue: number;
      advanceAmount: number;
      currentAmount: number;
      numDefaultAccounts: number;
      numServiceAccounts: number;
      numNotConnectedAccounts: number;
      serviceTotalDue: number;
      defaultTotalDue: number;
      pdcCount: number;
      periodInMonths: number;
      notConnectedTotalDue: number;
      numConnectedAccounts: number;
      checkDetails: Obj[];
      accountDetails: Obj[];
    }) => {
      
      const data = {
        ...unprocessedData,
        numServiceAccounts:
          unprocessedData.numServiceAccounts || this.numServiceAccounts,
        numDefaultAccounts:
          unprocessedData.numDefaultAccounts || this.numDefaultAccounts,
        numConnectedAccounts:
          unprocessedData.numConnectedAccounts || this.numConnectedAccounts,
        numNotConnectedAccounts:
          unprocessedData.numNotConnectedAccounts ||
          this.numNotConnectedAccounts,
        serviceTotalDue:
          unprocessedData.serviceTotalDue || this.serviceTotalDue,
        // defaultTotalDue:
        //   unprocessedData.defaultTotalDue || this.defaultTotalDue,
        connectedTotalDue:
          unprocessedData.connectedTotalDue || this.connectedTotalDue,
        notConnectedTotalDue:
          unprocessedData.notConnectedTotalDue || this.notConnectedTotalDue,
      };

      const res = await callRemoteMethod({
        endpoint: CONSTANTS.URL.CREATE_PAYMENT_PLAN,
        type: "POST",
        data: data,
      });
      runInAction(() => {
        this.plan = res.result;
      });
      

      return res;
    }
  );
resetPlan=()=>{
  runInAction(() => {
    this.plan = {};
  });
}
  uploadPDCDocuments = ErrorWrapper(async (documents: any) => {
    const res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.PDC_DOCUMENTS_UPLOAD,
      type: "POST",
      data: documents,
      file: true,
    });

    // runInAction(()=>{this.uploadResponse = res.result})
  });

  addServiceAccounts = (account: Obj) => {
    if (account.accountType == "DEFAULT") {
      this.numDefaultAccounts++;
      this.defaultTotalDue = Number(
        (this.defaultTotalDue + account.checkAmount).toFixed(2)
      );
    } else {
      this.numServiceAccounts++;
      this.serviceTotalDue = Number(
        (this.serviceTotalDue + account.checkAmount).toFixed(2)
      );
    }

    this.selectedServiceAccounts[account.accountId] = account;
  };

  addConnectorAccounts = (account: Obj) => {
    if (account.accountType == "CONNECTED") {
      this.numConnectedAccounts++;
      this.connectedTotalDue = Number(
        (this.connectedTotalDue + account.checkAmount).toFixed(2)
      );
    } else {
      this.numNotConnectedAccounts++;
      this.notConnectedTotalDue = Number(
        (this.notConnectedTotalDue + account.checkAmount).toFixed(2)
      );
    }

    this.selectedConnectorAccounts[account.accountId] = account;
  };

  removeServiceAccounts = (accountId: string) => {
    if (this.selectedServiceAccounts[accountId].accountType == "DEFAULT") {
      this.numDefaultAccounts--;
      this.defaultTotalDue = Number(
        (
          this.defaultTotalDue -
          this.selectedServiceAccounts[accountId].checkAmount
        ).toFixed(2)
      );
    } else {
      this.numServiceAccounts--;
      this.serviceTotalDue = Number(
        (
          this.serviceTotalDue -
          this.selectedServiceAccounts[accountId].checkAmount
        ).toFixed(2)
      );
    }

    delete this.selectedServiceAccounts[accountId];
  };

  removeConnectorAccounts = (accountId: string) => {
    // Reads the connector map, not the service one: a connector account is not
    // in selectedServiceAccounts, so the old lookup was undefined and
    // deselecting one corrupted the running total sent to CreatePayPlan.
    const account = this.selectedConnectorAccounts[accountId];

    if (account.accountType == "CONNECTED") {
      this.numConnectedAccounts--;
      this.connectedTotalDue = Number(
        (this.connectedTotalDue - account.checkAmount).toFixed(2)
      );
    } else {
      this.numNotConnectedAccounts--;
      this.notConnectedTotalDue = Number(
        (this.notConnectedTotalDue - account.checkAmount).toFixed(2)
      );
    }

    delete this.selectedConnectorAccounts[accountId];
  };

  validateAmount = ErrorWrapper(async (totalAmount: string) => {
    const data = {
      totalAmount,
    };

    const res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.VALIDATE_PDC_TOTAL_AMOUNT,
      type: "GET",
      data,
    });

    runInAction(() => {
      this.amountValidation = res.result;
    });
  });

  getBankDetails = ErrorWrapper(async () => {
    const res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.BANK_DETAILS,
    });

    runInAction(() => {
      this.bankDetails = res.result;
    });
  });
}

// async function getRequestHeader(file=false) {
//     let { info } = await User;
//     let { token } = await General;
//     var header = {
//       Accept: `application/${file ? 'octet-stream' : 'json'}`,
//       'Content-Type': `application/${file ? 'octet-stream' : 'json'}`, //'multipart/form-data',
//       currentLanguage: 'en-us',
//       mobile: '0506315292',
//     };

//     console.log("***keeetn:",info.token)
//     console.log("**token:", token && (header.Authorization = `Bearer ${token}`))
//     info.token ? (header.Authorization = `Bearer ${info.token}`) : token && (header.Authorization = `Bearer ${token}`) ;

//     return header;
//   }
const paymentPlanStore = new PaymentPlan();
export default paymentPlanStore;
